// @flow

import { useEffect, useState } from 'react';
import { getTbFarmerCustomersData } from 'insight/api/ThingsboardApiService';
import { useDispatch } from 'react-redux';
import PageContainer from 'insight/pages/common/PageContainer';
import CustomersDataGrid from 'insight/components/datagrid/farmer/CustomersDataGrid';
import { getChargeBeeCustomers, getChargeBeeSubscriptions } from 'insight/api/ChargeBeeApiService';
import PageTitle from '../../../common/components/PageTitle';

const FarmerAppCustomers = (): React$Node => {
  const dispatch = useDispatch();
  const [items, setItems] = useState([]);
  const [chargeBeeCustomers, setChargeBeeCustomers] = useState([]);
  const [chargeBeeSubscriptions, setChargeBeeSubscriptions] = useState([]);

  useEffect(() => {
    fetchCustomers();
  }, []);

  const fetchCustomers = () => {
    getTbFarmerCustomersData(dispatch).then(setItems);
    fetchChargeBeeCustomers();
    fetchSubscriptions();
  };

  const fetchSubscriptions = () => {
    getChargeBeeSubscriptions(dispatch).then((response) => setChargeBeeSubscriptions(response));
  };

  const fetchChargeBeeCustomers = () => {
    getChargeBeeCustomers(dispatch).then((response) => setChargeBeeCustomers(response));
  };

  return (
    <PageContainer>
      <PageTitle titleKey={'app.page.title.farmerApp.customers'} />
      <CustomersDataGrid
        items={items}
        fetchCustomers={fetchCustomers}
        chargeBeeCustomers={chargeBeeCustomers}
        chargeBeeSubscriptions={chargeBeeSubscriptions}
      />
    </PageContainer>
  );
};

export default FarmerAppCustomers;
